export const ROUTES = {
  HOME: '/',
  ACCOUNT: '/account',
  MY_INSPECTIONS: '/my_inspections',
  REQUEST_PASSWORD_RESET: '/request_password_reset',
  SIGN_OUT: '/users/sign_out',
  LOGGED_USER: '/api/v1/users/logged_user',
  VEHICLE_INSPECTIONS: '/api/v2/autovalid/vehicle_inspections',
  CREATE_INSPECTION: '/api/v2/autovalid/vehicle_inspections',
  SIGN_UP: '/api/v2/autovalid/users',
  UPDATE_USER: '/api/v2/autovalid/users',
  SCHEDULE: '/schedule',
  PAYMENT: '/payment',
  FINALIZATION: '/finalization',
  CREATE_PAYMENT: '/api/v2/autovalid/payments',
  PRICES: '/api/v2/autovalid/payments/prices',
  WALLET: '/api/v2/autovalid/wallet',
  PACKAGES: '/api/v2/autovalid/packages',
  CREATE_COMPANY: '/api/v2/autovalid/companies',
  PACKAGE_PAYMENT: '/package-payment',
};

export default ROUTES;